import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { getBlogBySlug } from "./blogApi";

function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogDetail();
  }, [slug]);

  const fetchBlogDetail = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getBlogBySlug(slug);
      setBlog(data.blog);
    } catch (err) {
      setError(err.message || "Failed to load blog");
      console.error("Error fetching blog:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="container" style={{ padding: "50px 0", textAlign: "center" }}>
          <p>Loading blog...</p>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !blog) {
    return (
      <>
        <Header />
        <div className="container" style={{ padding: "50px 0", textAlign: "center" }}>
          <p style={{ color: "red" }}>{error || "Blog not found"}</p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      {/*===== HERO AREA START =====*/}
      <div
        className="inner-hero"
        style={{
          backgroundImage: `url(${blog.image_url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="inner-main-heading">
                <h1>{blog.title}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== HERO AREA END =====*/}

      {/*=== BLOG DETAIL AREA START === */}
      <div className="blog-detail sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              {/* Featured Image */}
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={blog.image_url}
                  alt={blog.title}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }}
                />
              </div>

              {/* Blog Meta Information */}
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  marginBottom: "30px",
                  paddingBottom: "20px",
                  borderBottom: "1px solid #eee",
                }}
              >
                <span>
                  <i className="fa-solid fa-calendar"></i>{" "}
                  {new Date(blog.published_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
                <span>
                  <i className="fa-solid fa-tag"></i> {blog.status}
                </span>
              </div>

              {/* Blog Title */}
              <h1 style={{ marginBottom: "20px", fontSize: "32px", fontWeight: "bold" }}>
                {blog.title}
              </h1>

              {/* Blog Content */}
              <div
                className="blog-content"
                style={{
                  lineHeight: "1.8",
                  fontSize: "16px",
                  color: "#333",
                  marginBottom: "40px",
                }}
                dangerouslySetInnerHTML={{ __html: blog.content }}
              />

              {/* Back Button */}
              <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "1px solid #eee" }}>
                <a
                  href="/blog"
                  style={{
                    display: "inline-block",
                    padding: "10px 20px",
                    backgroundColor: "#007bff",
                    color: "white",
                    textDecoration: "none",
                    borderRadius: "4px",
                  }}
                >
                  ← Back to Blogs
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*=== BLOG DETAIL AREA END === */}

      <Footer />
    </>
  );
}

export default BlogDetail;
